import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { RoleBasedRouteGuard } from './auth/guards/role-based-route.guard';
import { OperationalGuard } from './operational/guards/operational.guard';

const routes: Routes = [
  {
    path: 'operational',
    loadChildren: () =>
      import('./operational/operational.module').then(
        (module) => module.OperationalModule
      ),
    canLoad: [AuthGuard, OperationalGuard],
    canActivate: [AuthGuard, OperationalGuard],
  },
  {
    path: 'moopi-settings',
    loadChildren: () =>
      import('./moopi-settings/moopi-settings.module').then(
        (module) => module.MoopiSettingsModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'foco',
    loadChildren: () =>
      import('./foco/foco.module').then((module) => module.FocoModule),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((module) => module.AccountModule),
  },
  {
    path: 'portfolio',
    loadChildren: () =>
      import('./portfolio/portfolio.module').then(
        (module) => module.PortfolioModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./orders/orders.module').then((module) => module.OrdersModule),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'campanhas',
    loadChildren: () =>
      import('./campanhas/campanhas.module').then(
        (module) => module.CampanhasModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./campaigns/campaigns.module').then(
        (module) => module.CampaignsModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'reporting',
    loadChildren: () =>
      import('./reporting/reporting.module').then(
        (module) => module.ReportingModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'opportunities',
    loadChildren: () =>
      import('./opportunities/opportunities.module').then(
        (module) => module.OpportunitiesModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'external',
    loadChildren: () =>
      import('./external/external.module').then(
        (module) => module.ExternalModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'pim',
    loadChildren: () =>
      import('./pim/pim.module').then((module) => module.PimModule),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: 'lab',
    loadChildren: () =>
      import('./lab/lab.module').then(
        (module) => module.LabModule
      ),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./home/home.module').then((module) => module.HomeModule),
    canLoad: [AuthGuard, RoleBasedRouteGuard],
    canActivate: [AuthGuard, RoleBasedRouteGuard],// Ensure a valid default route
  },
  {
    // The cookie policy (Microsoft Clarity), public so the banner's "Saber mais" works before sign-in.
    path: 'cookies',
    loadComponent: () =>
      import('./account/cookies-page/cookies-page.component').then(
        (c) => c.CookiesPageComponent
      ),
  },
  {
    path: '**',
    redirectTo: '/account/login', // Ensure fallback is valid
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false, // Ensure PathLocationStrategy is used
      scrollPositionRestoration: 'enabled', // Optional: Restores scroll position on navigation
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}